<template></template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'TodoFilterHandler',

    methods: {
        handleHomeRoute(client) {
            let html = ''
            if (client === null) {
                html = '-'
            } else {
                html += `<a href="${client.home_route}" title="Page d'accueil de la société">`
                html += client.name
                html += '</a>'
            }
            return html
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
            todoFilter: (state) => state.browsing.todoFilter,
        }),

        filteredItems() {
            if (this.todoFilter === 'late') {
                return this.lateItems
            }
            if (this.todoFilter === 'soon') {
                return this.soonItems
            }
            if (this.todoFilter === 'done') {
                return this.doneItems
            }
            return this.unDoneItems
        },

        lateItems() {
            return this.items.filter((item) => item.late)
        },

        soonItems() {
            return this.items.filter((item) => item.soon)
        },

        doneItems() {
            return this.items.filter((item) => item.done)
        },
        unDoneItems() {
            return this.items.filter((item) => !item.done)
        },
    },
}
</script>

<style scoped></style>
